import { Component, ViewChild, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TourResumeAdmin } from 'src/app/business/models/tour/tour-resume-admin.model';
import { AdminTourInteractor } from 'src/app/domain/interactor/admin/tour.interactor';
import { MessagePanelComponent } from 'src/app/ui/components/shared/message-panel/message-panel.component';
import { ServerErrorManager } from 'src/app/ui/components/utils/server-error-manager.utils';

import { marker as I18N }               from '@biesbjerg/ngx-translate-extract-marker';
import { GenericException } from 'src/app/domain/exceptions/generic.exception';


@Component({
  selector: 'app-admin-edit-tour-commission-modal-component',
  templateUrl: './edit-commission-modal.component.html'
})

export class AdminEditTourCommissionModalComponent {

  @ViewChild(MessagePanelComponent, { static: false })
  private messagePanelComponent: MessagePanelComponent;

  commissionForm: FormGroup;
  refreshValidators: boolean;
  defaultCommissionFare: number;


  @Input()
  set tourResume(tourResume: TourResumeAdmin) {
    if (tourResume) {
      this.commissionForm.get('tourId').setValue(tourResume.id);
      this.defaultCommissionFare = tourResume.defaultCommissionFare * 100;

      if ( tourResume.customCommissionFare != null ) {
           this.commissionForm.get('commission').setValue(tourResume.customCommissionFare * 100);
      }
    }
  }



  constructor(
    private adminTourInteractor: AdminTourInteractor,
    private serverErrorManager: ServerErrorManager,
    private modal: NgbActiveModal) {

    this.refreshValidators = false;

    this.commissionForm = new FormGroup({
      'tourId': new FormControl(''),
      'commission': new FormControl('', [Validators.max(100), Validators.min(0), Validators.pattern("^[0-9]*$")]),
    })

  }

  ngOnInit() {
  }


  closeModal() {
    this.modal.close();
  }


  saveCommission() {
    this.refreshValidators = true;

    if (this.commissionForm.valid) {

      this.messagePanelComponent.showLoading();

      const tourId: number = this.commissionForm.get('tourId').value;
      const commission: number = this.commissionForm.get('commission').value;
      let commissionAsPercentage: number = null;
      if ( commission != null ) {
           commissionAsPercentage = commission / 100;
      }

      this.adminTourInteractor.updateTourCommission(tourId, commissionAsPercentage)
        .subscribe(
          (tourResumeUpdated: TourResumeAdmin) => {

            MessagePanelComponent.hideLoading();
            this.messagePanelComponent.showSuccessMessage(I18N('editcommission.Información actualizada'));
            this.modal.close(tourResumeUpdated);

          },
          (error: GenericException) => {

            MessagePanelComponent.hideLoading();
            this.serverErrorManager.manageErrorCode(error, this.messagePanelComponent);

          }
        )

    }

  }


}




